var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfileCredit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0333 11.2916C14.6833 11.6332 14.4833 12.1249 14.5333 12.6499C14.6083 13.5499 15.4333 14.2082 16.3333 14.2082H17.9166V15.1999C17.9166 16.9249 16.5083 18.3333 14.7833 18.3333H5.21659C3.49159 18.3333 2.08325 16.9249 2.08325 15.1999V9.59159C2.08325 7.86659 3.49159 6.45825 5.21659 6.45825H14.7833C16.5083 6.45825 17.9166 7.86659 17.9166 9.59159V10.7916H16.2333C15.7666 10.7916 15.3416 10.9749 15.0333 11.2916Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08325 10.3416V6.5333C2.08325 5.54163 2.69159 4.65826 3.61659 4.30826L10.2333 1.80826C11.2666 1.41659 12.3749 2.18329 12.3749 3.29162V6.45828",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7989 11.6417V13.3584C18.7989 13.8168 18.4323 14.1917 17.9656 14.2084H16.3323C15.4323 14.2084 14.6073 13.5501 14.5323 12.6501C14.4823 12.1251 14.6823 11.6334 15.0323 11.2917C15.3406 10.9751 15.7656 10.7917 16.2323 10.7917H17.9656C18.4323 10.8084 18.7989 11.1834 18.7989 11.6417Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83325 10H11.6666",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileCredit);
export default __webpack_public_path__ + "static/media/profile-credit.8192c9ba41aa0dce0f4863b3de9af419.svg";
export { ForwardRef as ReactComponent };